import React, { useState, useRef, useEffect } from 'react';

const BorderedBox = React.forwardRef(function BorderedBox(
  { children, style = {}, collapsible = false, defaultVisible = true, exposeCollapsed },
  ref
) {
  const [visible, setVisible] = useState(defaultVisible);

  const childrenArray = React.Children.toArray(children);
  const header = collapsible ? childrenArray[0] : null;
  const content = collapsible ? childrenArray.slice(1) : childrenArray;

  const contentRef = useRef(null);
  const [height, setHeight] = useState('auto');

  // Update external state if requested
  useEffect(() => {
    if (typeof exposeCollapsed === 'function') {
      exposeCollapsed(!visible);
    }
  }, [visible, exposeCollapsed]);

  // Animate content height
  useEffect(() => {
    if (visible && contentRef.current) {
      setHeight(contentRef.current.scrollHeight + 'px');
    } else {
      setHeight('0px');
    }
  }, [visible, content.length]);

  return (
    <div
      ref={ref}
      style={{
        backgroundColor: 'var(--bg-card)',
        padding: '1rem',
        overflow: 'visible',
        borderRadius: '12px',
        boxShadow: '0 1px 6px rgba(0, 0, 0, 0.15)',
        border: '1px solid var(--card-border)',
        paddingLeft: '10px',
        paddingRight: '10px',
        boxSizing: 'border-box',
        width: '100%',
        ...style,
      }}
    >
      {collapsible ? (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ flex: 1 }}>{header}</div>
            <button
              onClick={() => setVisible((v) => !v)}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '1.1rem',
                color: '#888',
                cursor: 'pointer',
              }}
              title={visible ? 'Hide filters' : 'Show filters'}
            >
              <svg width="24" height="24" viewBox="0 0 20 20">
                <path d={visible ? 'M5 12l5-5 5 5' : 'M5 8l5 5 5-5'} fill="none" stroke="#aaa" strokeWidth="2" />
              </svg>
            </button>
          </div>

      <div
  style={{
    overflow: 'hidden',
    transition: 'max-height 0.15s ease, opacity 0.15s ease',
    maxHeight: visible ? 'none' : height,
    opacity: visible ? 1 : 0,
    marginTop: visible ? '0.75rem' : '0',
  }}
>

            <div ref={contentRef}>{content}</div>
          </div>
        </>
      ) : (
        children
      )}
    </div>
  );
});

export default BorderedBox;
